import { Component, Input, ViewChild } from '@angular/core';
import { NavController, NavParams, PopoverController, ModalController, ViewController, Events } from 'ionic-angular';

import { CoBookScannerPopoverComponent } from '../../components/co-book-scanner-popover/co-book-scanner-popover';
import { IlsProvider } from '../../providers/ils/ils';
import moment from 'moment';
import { PatronProvider } from '../../providers/patron/patron';
import { AppState } from '../../config/state';
import { ConfigProvider } from '../../providers/config/config';
import { LoadingController } from 'ionic-angular';
import { LoginProvider } from '../../providers/login/login';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { CoLogoutSurveyPage } from '../../pages/co-logout-survey/co-logout-survey';
import { MailProvider } from '../../providers/mail/mail';
import { CoEmailInputComponent } from '../co-email-input/co-email-input';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { NovelistProvider } from '../../providers/novelist/novelist';
import { IpcService } from '../../providers/ipc/ipc';
import { PrintingProvider } from '../../providers/printing/printing';
import { CoFailedItemCheckoutModalPage } from '../../pages/co-failed-item-checkout-modal/co-failed-item-checkout-modal';
import { BibItem } from '../../providers/item/item';


@Component({
  selector: 'co-checkout',
  templateUrl: 'co-checkout.html',
  inputs: ['screenType', 'printEnabled']
})
export class CoCheckoutComponent {
  @Input('locationId') locationId: number;
  @Input('screenType') screenSetting: string;
  @Input('printEnabled') printEnabled: boolean;
  @Input('pinlessOverride') pinlessOverride: boolean = false;
  modal: any;
  scanInfo: any;
  bookList: any = [];
  renewBookList: any = [];
  idents: any = [];
  patron: any = { email: '', phone: '' };
  ifRecommended: boolean;
  patronLoggedIn: boolean;
  returnDate: string = moment().add(1, 'month').format("YYYY-MM-DD HH:mm:ss");
  isForApp: boolean;
  isbnObj: any = {};
  viewType: any;
  showLoginCheckin: boolean = false;
  buttonText: string;
  indicatorState: number;
  errorCounter: number = 0;
  isConfirmationScreen: boolean = false;
  isLogoutScreen: boolean = false;
  loadingButton: boolean = false;
  headerText: string;
  failedCount: number = 0;
  pastTense: string;
  pastTenseEmail: string;
  emailText: string;
  failScreen: boolean = false;
  isPrintEnabled: boolean = false;
  emailRegex: any;
  phoneRegex: any;
  bookQueryCount: number = 0;
  timeOfSubmit: any;
  showRecReads: boolean;
  validCheck: { email: boolean, phone: boolean } = { email: true, phone: true };
  pickupLocations: any;
  itemForRenew: boolean = false;
  showRenewList: boolean = false;
  scanHelpMessage: string;
  private listenForScan: boolean = false;
  private listening: boolean = false;
  private currentScan: any = [];
  @ViewChild('whereRecommendedGoes') recReads: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, public toast: ToastAlertsProvider, public popoverCtrl: PopoverController, public ilsProvider: IlsProvider, public patronProvider: PatronProvider, public state: AppState, public config: ConfigProvider, public loading: LoadingController, public modalCtrl: ModalController, private viewCtrl: ViewController, private loginProvider: LoginProvider, private events: Events, private mailProvider: MailProvider, private timeout: TimeoutFunctionsProvider, private novelist: NovelistProvider, private ipc: IpcService, private printingProvider: PrintingProvider) {
    this.isForApp = this.state.cordovaAvailable;
    if (this.state.loggedInPatronId && this.state.patron) {
      this.patronLoggedIn = true;
      this.patron = this.state.patron;
    } else {
      this.patronLoggedIn = false;
    };
    this.events.subscribe('patronLoggedIn', (login) => {
      this.patronLoggedIn = login;
    });
    this.events.subscribe('timeoutCalled', () => this.timeout.doLogoutFunctions(this));
    this.viewType = this.state.mode;
    this.startScanListener();
    this.scanHelpMessage = "Scan another item or tap done" // TODO: ADD setting from control panel in client settings
    this.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.phoneRegex = new RegExp('^[^a-zA-Z]*$');
    this.indicatorState = 0;
    this.showRecReads = this.state.showNovelistOnLogout ? true : false;
    // this.state.loggedInPatronId? this.patronLoggedIn  = true : this.patronLoggedIn = false;
    // this.events.subscribe('patronLoggedIn', login => {
    //   this.patronLoggedIn = login;
    // });
    // this.loading.create({content: 'weeooooo'}).present();
    // console.log('details', this.patron, this.patronLoggedIn, this.state.patron, this.state);
  }

  ngOnInit(): void {
    // let view = this.navCtrl.getActive();
    // view.onDidDismiss(()=>{
    //   console.log('gone')
    // });
    // console.log(this.locationId);
    if (!this.locationId) {
      this.locationId = this.state.locationId;
      // console.log(this.locationId);
    }
    this.listenForScan = true;
    if (!this.bookList || this.bookList.length <= 0) {
      if (this.patronLoggedIn) {
        this.checkPatronData()
      } else {
        this.loginProvider.requireLogin((res) => {
          // console.log('this equals es', res)
          this.patron = this.state.patron;
          this.patronLoggedIn = true;
          this.checkPatronData();
        }, undefined, this.pinlessOverride);
      }
    }
    switch (this.screenSetting) {
      case ('checkin'):
        this.buttonText = 'check in';
        this.headerText = 'check ins';
        this.pastTense = 'checked in';
        this.pastTenseEmail = 'returned';
        this.emailText = 'Check-IN'; //these should be in client settings in future
        break;
      case ('checkout'):
        this.buttonText = 'check out';
        this.headerText = 'checkouts';
        this.pastTense = 'checked out';
        this.pastTenseEmail = 'checked out';
        this.emailText = 'Checkout';
        break;
      case ('renew'):
        this.buttonText = 'renew';
        this.headerText = 'renewals';
        this.pastTense = 'renewed';
        this.pastTenseEmail = 'renewed';
        this.emailText = 'Renew';
        break;
      case ('holds'):
        this.buttonText = 'hold';
        this.headerText = 'holds';
        this.pastTense = 'held items';
        this.pastTenseEmail = 'held items';
        this.emailText = 'Holds';
        break;
    }
  }


  startScanListener() {
    window.addEventListener('keyup', (e) => {
      if (this.listenForScan && this.patronLoggedIn) {
        // check the keys pressed are numbers
        if (e.which >= 32 && e.which <= 122) {
          // if a number is pressed we add it to the chars array
          this.currentScan.push(String.fromCharCode(e.which));
        } else if (e.which === 13) {
          //enter key, scan must be done. TODO: use this, not scan length...
        }
        if (this.listening == false) {
          // we set a timeout function that expires after .5 sec, once it does it clears out a list of characters
          setTimeout(() => {
            if (this.currentScan.length >= 4) {
              const barcode = this.currentScan.join("");
              if (this.bookList.findIndex(b => b.barcode == barcode) === -1) {
                this.getBookInfoAndCheckout(barcode);
              } else {
                this.toast.triggerToast("You have already checked out this item!", '', 'warning', 6000);
              }
            }
            this.currentScan = [];
            this.listening = false;
          }, 450);
        }
        // set press to true so we do not reenter the timeout function above
        this.listening = true;
      }
    });
  }
  ngOnDestroy() {
    this.listenForScan = false;
  }

  createBookScannerPopover() {
    let customClass = 'custom-barcode-scanner-popover';
    let popover = this.popoverCtrl.create(CoBookScannerPopoverComponent, { type: 'book' }, { cssClass: customClass });
    popover.present({
      ev: '',
      animate: false
    });
    this.listenForScan = false;

    popover.onDidDismiss(data => {
      this.listenForScan = true;
      if (data && data.info) {
        // let counter: number = 0;
        // this.bookList.forEach(book => {
        //   if (book.barcode === data.info) {
        //     counter++;
        //   };
        // });
        // if (counter === 0) {
        //   this.getBookInfoAndCheckout(data.info);
        // } else {
        //   this.toast.triggerToast("You've entered this item already!", '');
        // };
        if (this.bookList.findIndex(b => b.barcode == data.info) === -1) {
          this.getBookInfoAndCheckout(data.info);
          // console.log('new item')
        } else {
          // console.log('same item');
          setTimeout(() => {
            this.toast.triggerToast("You have already checked out this item!", '', 'warning', 6000);
          }, 500);
        }
        // popover.present({
        //   ev: ''  UN-COMMENT IF WE WANT POPUP TO COME BACK AGAIN AFTER EACH SCAN
        // });
      };
    });
  }

  checkPatronData() {
    let content = '';

    switch (this.screenSetting) {
      case ('renew'):
        content = 'Getting account checkouts...'
        break;
      case ('holds'):
        content = 'Getting account holds...'
        break;
      default:
        content = 'Getting account details...'
        break;
    }

    let loader = this.loading.create({
      content: content,
    });
    loader.present();
    // console.log('before', this.state.patron);
    if (this.screenSetting === 'renew') {
      // console.log('info', info)
      this.patronProvider.getCheckouts(this.state.patron.barcode, this.state.patron.pin).then(checkouts => {
        if (checkouts && checkouts.length > 0) {
          // console.log(checkouts)
          checkouts.forEach(book => {
            if(book.bib){
              book.bib.displayState = 5;
              this.renewBookList.push(book);
              if (book.bib.upcs.length > 0) {
                this.isbnObj[book.bib.id] = { number: book.bib.upcs[0], type: 'upc' };
                book.bib.isbnObj = { number: book.bib.upcs[0], type: 'upc' };
              } else if (book.bib.isbns.length > 0) {
                this.isbnObj[book.bib.id] = { number: book.bib.isbns[0], type: 'isbn' };
                book.bib.isbnObj = { number: book.bib.isbns[0], type: 'isbn' };

              }
            }
          })
        }
        this.showRenewList = true;
        loader.dismiss().catch(err=>{});
      })
    } else if (this.screenSetting === 'holds') {
      this.patronProvider.getHolds(this.state.patron.barcode, this.state.patron.pin).then(holds => {
        if (holds && holds.length > 0) {
          // console.log(holds);
          holds.forEach(book => {
            if (book.bib) {
              book.bib.displayState = 7;
              this.renewBookList.push(book);
              if (book.bib.upcs.length > 0) {
                this.isbnObj[book.bib.id] = { number: book.bib.upcs[0], type: 'upc' };
                book.bib.isbnObj = { number: book.bib.upcs[0], type: 'upc' };
              } else if (book.bib.isbns.length > 0) {
                this.isbnObj[book.bib.id] = { number: book.bib.isbns[0], type: 'isbn' };
                book.bib.isbnObj = { number: book.bib.isbns[0], type: 'isbn' };
              }
            }
          })

        }
        this.showRenewList = true;
        loader.dismiss().catch(err=>{});
      })
    } else {
      loader.dismiss().catch(err=>{});
      this.createBookScannerPopover();
    }


  }


  getBookInfoAndCheckout(info) {
    let loader;
    if (this.screenSetting === 'checkout') {
      this.timeOfSubmit = moment();
      loader = this.loading.create({
        content: 'Checking out item...',
		duration: 5000
      });
      loader.present();
	} else if (this.screenSetting === 'checkin') {
      this.timeOfSubmit = moment();
      loader = this.loading.create({
        content: 'Checking in item...',
		duration: 5000
      });
      loader.present();
    } else {
      console.log('you shouldnt see this', this.screenSetting)
    }
    if (this.state.demo) { // *** THIS IS DEMO ONLY
      this.ilsProvider.getBibDetailsFromId(info).then((item) => {
        // console.log(item);
        item.barcode = info;
        if (item.upcs.length > 0) {
          this.isbnObj[item.id] = { number: item.upcs[0], type: 'upc' };
          item.isbnObj = { number: item.upcs[0], type: 'upc' };
        } else if (item.isbns.length > 0) {
          this.isbnObj[item.id] = { number: item.isbns[0], type: 'isbn' };
          item.isbnObj = { number: item.isbns[0], type: 'isbn' };
        } else {
          this.isbnObj[item.id] = { number: null, type: false};
          item.isbnObj = {number: null, type: false};
        }
        item.displayState = 2; //passed
        item.returnDate = moment().add(4, 'weeks').format('MM/DD/YYYY');
        item.bookPassed = true;
        this.bookQueryCount++;
        this.bookList.push(item);
        loader.dismiss().catch(err=>{});
      }).catch((err) => {
        loader.dismiss().catch(err=>{});
        this.toast.triggerToast('Invalid item', '');
      })
    } else { // THIS IS THE REAL CHECKOUT CHECKIN PART
      if (this.screenSetting === 'checkin') {//TODO: convert this to the new method
        this.ilsProvider.getItemFromBarcode(info).then((item) => {
          const bib = item.bib;
          bib.barcode = info;
          if (bib.upcs.length > 0) {
            this.isbnObj[bib.id] = { number: bib.upcs[0], type: 'upc' };
            bib.isbnObj = { number: bib.upcs[0], type: 'upc' };
          } else if (bib.isbns.length > 0) {
            this.isbnObj[bib.id] = { number: bib.isbns[0], type: 'isbn' };
            bib.isbnObj = { number: bib.isbns[0], type: 'isbn' };
          }
          this.ilsProvider.checkinBook(bib.barcode, this.state.locationId.toString()).then(checkin => {
            // console.log(checkin);
            if (checkin) {
              bib.bookPassed = checkin.status;
              bib.responseInfo = checkin;
              if (checkin.status) {
                bib.displayState = 2; //passed
                bib.returnDate = checkin.dueDate;
                this.bookQueryCount++;
                this.bookList.push(bib);
                loader.dismiss().catch(err=>{});
              } else {
                bib.displayState = 3; //failed
                this.failedCount++;
                this.bookQueryCount++;
                this.bookList.push(bib);
                loader.dismiss().catch(err=>{});
                // console.log(book.message)
              }
            } else {
              bib.displayState = 3;
              this.failedCount++;
              this.bookList.push(bib);
              loader.dismiss().catch(err=>{});
            }
          })
        }).catch((err) => {
          loader.dismiss().catch(err=>{});
          this.toast.triggerToast('Invalid item', '');
        })
      }else if (this.screenSetting === 'checkout') {
        try{
          this.novelist.getItemDetailsFromBarcode(info);
        }catch(err){}
        this.ilsProvider.checkoutBook(this.patron.barcode, info, this.state.locationId.toString(), this.patron.pin).then(checkout => {
          const bib:BibItem = {};
          if (checkout) {
            if(!checkout.item)throw new Error(checkout.message);
            bib.bookPassed = checkout.status;
            bib.responseInfo = checkout;
            bib.title = checkout.item.titleIdentifier;
            bib.format = checkout.item.mediaType;
            bib.barcode = info;
            if (checkout.status) {
              bib.displayState = 2; //passed
              bib.returnDate = checkout.dueDate;
              this.bookQueryCount++;
              this.bookList.push(bib);
              this.playSound(true);
              loader.dismiss().catch(err=>{});
            } else {
              bib.displayState = 3; //failed
              this.failedCount++;
              this.bookQueryCount++;
              this.bookList.push(bib);
              this.playSound(false);
              loader.dismiss().catch(err=>{});
              // console.log(book.message)
            }
          } else {
            bib.displayState = 3;
            bib.title = "Unknown item";
            this.failedCount++;
            this.bookList.push(bib);
            this.playSound(false);
            loader.dismiss().catch(err=>{});
          }
        }).catch((err) => {
          this.playSound(false);
          loader.dismiss().catch(err=>{});
          this.toast.triggerToast(err, '');
        });
      }

    }

  }
  playSound(status){
    if (this.state.enableSounds) {
      const sound = status?new Audio('assets/sounds/checkoutsuccess.mp3'):new Audio('assets/sounds/checkoutfailed.mp3');
      sound.loop = false;
      sound.play();
    }
  }
  removeBook(bookTag) {
    // let bookIndex = 0;
    // this.bookList.forEach((book, i) => {
    //   if (book.barcode === bookTag) {
    //     bookIndex = i;
    //   }
    // });
    this.bookList.splice(bookTag, 1);
  }

  setBookForRenew(book) {
    // console.log('renew this', book);
    if (book.bib.displayState === 5) {
      book.bib.displayState = 0;
    } else if (book.bib.displayState === 0) {
      book.bib.displayState = 5;
    } else {
      // console.log('error', book.bib.displayState);
    }
  }

  goToNext() {
    this.timeOfSubmit = moment();
    if (this.screenSetting !== 'renew') {
      if (this.bookList.length > 0) {
        this.bookList.forEach(book => {
          book.displayState = 1;
        });
        this.loadingButton = true;
        switch (this.screenSetting) {
          case ('checkout'):
            this.bookList.forEach((book, i) => {
              if (this.state.demo) {
                // console.log('demo mode')
                book.bookPassed = true
                book.displayState = 2; //passed
                book.returnDate = moment().add(4, 'weeks');
                this.bookQueryCount++;
                if (this.bookQueryCount >= this.bookList.length) {
                  this.goToConfirmationScreen();
                }
              } else {
                this.ilsProvider.checkoutBook(this.patron.barcode, book.barcode, '76', this.patron.pin).then(res => {
                  // console.log(res)
                  if (res) {
                    book.bookPassed = res.status;
                    book.responseInfo = res;
                    if (res.status) {
                      book.displayState = 2; //passed
                      book.returnDate = res.dueDate;
                      this.bookQueryCount++;
                    } else {
                      book.displayState = 3; //failed
                      this.failedCount++;
                      this.bookQueryCount++;
                      // console.log(book.message)
                    }
                  } else {
                    book.displayState = 3;
                    this.failedCount++;
                  }
                  if (this.bookQueryCount >= this.bookList.length) {
                    this.goToConfirmationScreen();
                  }
                });
              }
            });
            break;
          case ('checkin'):
            this.bookList.forEach((book, i) => {
              if (this.state.demo) {
                // console.log('demo mode')
                book.bookPassed = true
                book.displayState = 2; //passed
                this.bookQueryCount++;
                if (this.bookQueryCount >= this.bookList.length) {
                  this.goToConfirmationScreen();
                }
              } else {
                this.ilsProvider.checkinBook(book.barcode, this.state.locationId.toString()).then(res => {
                  if (res) {
                    book.bookPassed = res.status;
                    book.responseInfo = res;
                    if (res.status) {
                      book.displayState = 2; //passed
                      this.bookQueryCount++;
                    } else {
                      book.displayState = 3; //failed
                      this.failedCount++;
                      this.bookQueryCount++;
                      // console.log(book.message)
                    }
                  } else {
                    book.displayState = 3;
                    this.failedCount++;
                  }
                  if (this.bookQueryCount >= this.bookList.length) {
                    this.goToConfirmationScreen();
                  }
                });
              }
            });
          case ('renew'):
            this.bookList.forEach(book => {
              //this.ilsProdiver.renew(book.barcode).then(res =>{
              //   if (res){
              //     book.bookPassed = res;
              //   };
              // });
            });
        }
      } else {
        this.toast.triggerToast('Please scan an item', '');
      }
    } else {
      if (this.renewBookList.length > 0) {
        this.renewBookList.forEach(item => {
          if (item.bib.displayState === 0) this.itemForRenew = true;
        });
        if (this.itemForRenew) {
          if (this.state.demo) {
            this.renewBookList.forEach(book => {
              // console.log('weebook', book)
              if (book.bib.displayState === 0) {
                book.bib.displayState = 1;
                book.barcode = book.bib.barcode;

                book.bib.checkoutId = book.id;
                book.bib.dueDate = book.dueDate;
                book.bib.outDate = book.outDate;
                book.bib.bib = book.bib;
                this.bookList.push(book.bib);
              } else {
                book.bib.displayState = 6; //just hides all options for ignored books
              }
            });
            this.loadingButton = true;
            this.bookList.forEach((book, i) => {
              // console.log(res)
              book.bookPassed = true;
              book.displayState = 2; //passed
              book.dueDate = moment(book.dueDate).add(1, "week");
              this.bookQueryCount++;
              if (this.bookQueryCount >= this.bookList.length) {
                this.goToConfirmationScreen();
              }
            });
          } else {
            this.renewBookList.forEach(book => {
              // console.log('weebook', book)
              if (book.bib.displayState === 0) {
                book.bib.displayState = 1;
                book.barcode = book.bib.barcode;

                book.bib.checkoutId = book.id;
                book.bib.dueDate = book.dueDate;
                book.bib.outDate = book.outDate;
                book.bib.bib = book.bib;
                this.bookList.push(book.bib);
              } else {
                book.bib.displayState = 6; //just hides all options for ignored books
              }
            });
            // console.log('uhoh', this.renewBookList, this.bookList);
            this.loadingButton = true;
            this.bookList.forEach((book, i) => {
              this.ilsProvider.renewBook(book.bib.checkoutId, this.patron.barcode).then(res => {
                // console.log(res)
                if (res) {
                  book.bookPassed = res.status;
                  book.bib.responseInfo = res;
                  if (res.status) {
                    book.displayState = 2; //passed
                    book.dueDate = res.dueDate;
                    this.bookQueryCount++;
                  } else {
                    book.displayState = 3; //failed
                    this.failedCount++;
                    this.bookQueryCount++;
                    // console.log(book.message)
                  }
                } else {
                  book.displayState = 3;
                  this.failedCount++;
                }
                if (this.bookQueryCount >= this.bookList.length) {
                  this.goToConfirmationScreen();
                }
              });
            });
          }
        } else {
          this.toast.triggerToast("Please choose an item to renew!", "");
        }
      } else {
        this.toast.triggerToast("You have no items to renew!", "");
        this.viewCtrl.dismiss().catch(err=>{});;
      }
    }
  }
  renewAll(){
    this.renewBookList.forEach(async book => {
      await this.goToNextRenew(book);
    });
  }
  goToNextRenew(book) {
    book.bib.displayState = 1;
    book.barcode = book.bib.barcode;
    book.bib.checkoutId = book.id;
    book.bib.dueDate = book.dueDate;
    book.bib.outDate = book.outDate;
    book.bib.bib = book.bib;
    // console.log(book, this.patron)
    return this.ilsProvider.renewBook(book.bib.checkoutId, this.patron.barcode, this.patron.pin).then(res => {
      if (res) {
        book.bookPassed = res.status;
        book.bib.responseInfo = res;
        if (res.status) {
          book.bib.displayState = 2; //passed
          book.dueDate = res.dueDate;
        } else {
          book.bib.displayState = 3; //failed
          if (res.message && res.message.length > 0) {
            book.bib.errorMessage = res.message;
          }
          // console.log(book.message)
        }
      } else {
        book.displayState = 3;
      }
    });
  }

  goToNextCancelHold(book) {
    // console.log(this.patron, this.state.patron)
    book.bib.displayState = 1;
    this.ilsProvider.cancelHold(this.state.patron.barcode, book.id, this.patron.pin).then(res => {
      if (res) {
        book.bookPassed = res.status;
        book.bib.responseInfo = res;
        if (res.status) {
          book.bib.displayState = 8;
        } else {
          book.bib.displayState = 3;
        }
      } else {
        book.displayState = 3;
      }
    })
  }

  checkItemBackIn(book, i) {
    let loader = this.loading.create({ content: "Canceling checkout..." });
    loader.present();
    if (this.state.demo) {
      loader.dismiss().catch(err=>{});
      this.bookList.splice(i, 1);
      this.toast.triggerToast('Your checkout has been cancelled', "", 'success', 2000);
    } else {
      this.ilsProvider.checkinBook(book.barcode, this.state.locationId.toString()).then(res => {
        if (res && res.status) {
          loader.dismiss().catch(err=>{});
          this.bookList.splice(i, 1);
          this.bookQueryCount--;
          this.toast.triggerToast('Your checkout has been cancelled', "", 'success', 2000);
        } else {
          loader.dismiss().catch(err=>{});
          this.toast.triggerToast(res.message || "Error handling request, please see a librarian", "", 'warning', 2000);
        }
      })
    }
  }

  printRenewHoldsScreen() {
    let screenType = "";
    this.screenSetting === 'renew' ? screenType = "Checkouts" : screenType = "Holds";
    this.printingProvider.printCurrentCheckoutsHolds({ receiptInfo: this.renewBookList, screenType: screenType, patron: this.patron, pastTense: this.pastTense, submitTime: this.timeOfSubmit, idents: this.idents })
  }

  novelistLoaded(state) {
    this.ifRecommended = true;
  }

  async printInfo() {
    let details;
    if (this.idents && this.idents.length > 0) {
      for (let ident of this.idents) {
        if (details) break;
        if (ident.type == 'isbn') {
          details = await this.novelist.getItemDetailsFromISBN(ident.id);
        } else if (ident.type == 'upc') {
          details = await this.novelist.getItemDetailsFromUPC(ident.id);
        }else if (ident.type=='barcode'){
          details = await this.novelist.getItemDetailsFromBarcode(ident.id);
        }
      };
    }
    // console.log(this.idents, details)
    this.ipc.send('printItemCheckoutReceipt', {
      patron: this.patron,
      books: this.bookList,
      similarTitles: details && details.similarTitles ? details.similarTitles : false,
      screenType: this.screenSetting
    });
    //printing Function
    // console.log('printing', this.bookList, 'current screen', screen);
  }

  goToConfirmationScreen() {
    if (this.bookList.length > 0) {
      this.loadingButton = false;
      // if (this.state.demo){
      //   this.idents = this.bookList.reduce((ret, book) => {
      //     const bib = book;
      //     ret.push({ type: 'bibId', id: book.id });
      //     return ret;
      //   }, []);
      // } else {
      this.idents = this.bookList.reduce((ret, book) => {
        ret.push({type:'barcode', id: book.barcode});
        const bib = book;
        if(bib.isbns)ret.push(...bib.isbns.map(i => { return { type: 'isbn', id: i } }))
        if(bib.upcs)ret.push(...bib.upcs.map(i => { return { type: 'upc', id: i } }))
        return ret;
      }, []);
      // }
      // console.log('nove', this.idents)
      this.bookList.forEach(book => {
        if (!book.bookPassed) this.errorCounter++;
      });
      this.isConfirmationScreen = true;
      if (this.screenSetting === 'renew') this.renewBookList = this.bookList;
    } else {
      this.toast.triggerToast(`Please ${this.buttonText} an item!`, "", 'warning');
    }
  }

  sendReceipt(notification, event) {
    let inputPopup;
    let customClass = 'custom-email-input-popover';
    let successfulItems = 0;
    if (this.bookList.length > 0) successfulItems += this.bookList.filter(i => i.bookPassed).length;
    switch (notification) {
      case ('email'):
        inputPopup = this.popoverCtrl.create(CoEmailInputComponent, { inputType: 'email' }, { cssClass: customClass });
        let barcodeDetails, emailVars;
        let emailList = "";
        inputPopup.present({ ev: event });
        inputPopup.onDidDismiss(email => {
          if (email && email.info) {
            this.bookList = this.bookList.filter( book=>{
              return book.bookPassed;
            })
            this.bookList.forEach(book => {
            //   let status;
            //   book.bookPassed ? status = 'Passed' : status = 'Failed';
              emailList += `Title: ${book.title} \r\n Id: ${book.id} \r\n Due: ${moment(book.returnDate).format('MM/DD/YYYY')} \r\n \r\n`
            });
            if (this.patron.id) {
              barcodeDetails = `Customer ID: **********${this.patron.barcode.split('').reverse().slice(0, 4).reverse().join('')}`
            }
            emailVars = {
              first_name: '',
              screen_type: this.emailText,
              branch_name: '',
              barcode_end: barcodeDetails || '',
              book_list: encodeURIComponent(emailList),
              // book_list: emailList,
              past_tense: this.pastTenseEmail,
              total: this.bookList.length
            }
            this.patron && this.patron.firstName ? emailVars.first_name = this.patron.firstName : emailVars.first_name = '';
            this.mailProvider.sendBookReceipt(email.info, emailVars, true).then(res => {
              if (res.status) {
                this.toast.showAlert('', 'Your receipt has been sent!', 'success');
                this.isLogoutScreen = true;
              } else {
                this.toast.triggerToast('Send failed, please retry', '');
              };
            });
          }
        });
        break;
      case ('phone'):
        inputPopup = this.popoverCtrl.create(CoEmailInputComponent, { inputType: 'phone' }, { cssClass: customClass });
        inputPopup.present({ ev: event });
        inputPopup.onDidDismiss(phone => {
          if (phone && phone.info) {
            // console.log(this.patron.firstName)
            this.mailProvider.sendBookReceipt(`1${phone.info}`, { first_name: this.patron.firstName || "", screen_type: this.buttonText, branch_name: this.state.branchInformation.name, total: successfulItems }, false).then(res => {
              if (res.status) {
                this.toast.triggerToast('Your receipt has been sent!', '', 'success');
                this.isLogoutScreen = true;
              } else {
                this.toast.triggerToast('Send failed, please retry', '');
              }
            });
          }
        });

        // if (this.patron.phone.length > 0 && this.patron.phone.length < 11) {
        //   if (this.phoneRegex.test(this.patron.phone)) {
        //     this.patron.phone = this.patron.phone.replace(/\D/g, '');
        //     this.patron.phoneValid = true;
        //     //TODO: Added a 1 for US number code, will have to pull in from client settings in future
        //   } else {
        //     this.toast.triggerToast('Please enter a valid phone number!', '');
        //     this.patron.phoneValid = false;
        //   }
        // } else {
        //   this.toast.triggerToast('Please enter a valid phone number!', '');
        //   this.patron.phoneValid = false;
        // }
        break;
      case ('print'):
        // console.log(this.bookList, this.patron, this.state, this.idents)
        // let preview = this.popoverCtrl.create(CoPrintPreviewPopoverComponent, { receiptInfo: this.bookList, screenType: this.emailText, patron: this.patron, pastTense: this.pastTense, submitTime: this.timeOfSubmit, idents: this.idents });
        // preview.present();
        this.printingProvider.printCheckoutItemReceipt({ receiptInfo: this.bookList, screenType: this.emailText, patron: this.patron, pastTense: this.pastTense, submitTime: this.timeOfSubmit, idents: this.idents }).then((logout)=>{
          if (logout) this.loginProvider.instantLogout();
        })
        this.isLogoutScreen = true;
        break;
      default:
        this.isLogoutScreen = true;
      break;
    }
  }

  openFailedDetailsModal(book) {
    // console.log(book.responseInfo);
    let popover = this.popoverCtrl.create(CoFailedItemCheckoutModalPage, { book: book }, { cssClass: 'failed-item-popover' });
    popover.present();
  }

  logOut(bool) {
    if (bool) {
      let modal = this.modalCtrl.create(CoLogoutSurveyPage, {}, { cssClass: 'full-screen-survey' });
      this.state.patron = null;
      this.loginProvider.logout();
      this.navCtrl.popToRoot();
      if (this.state.surveyEnabled) modal.present();
    } else {
      this.navCtrl.popTo(this.navCtrl.getByIndex(1));
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/co-checkout/co-checkout.ts